// Base French content — single source of truth. Admin overrides merge on top,
// and translations are generated from this object by the backend LLM endpoint.

export const IMAGES = {
  hero: "https://images.pexels.com/photos/11850543/pexels-photo-11850543.jpeg",
  coffee: "https://images.unsplash.com/photo-1722962883780-8806c3ab546b",
  cocoa: "https://images.unsplash.com/photo-1573710661345-610f790e1218?crop=entropy&cs=srgb&fm=jpg&q=85",
  lychee: "https://images.unsplash.com/photo-1783749924201-6253a9d202da?crop=entropy&cs=srgb&fm=jpg&q=85",
  export: "https://images.unsplash.com/photo-1578575437130-527eed3abbec",
  b2b: "https://images.pexels.com/photos/9490632/pexels-photo-9490632.jpeg",
};

export const defaultContent = {
  ui: {
    brand: "Lauréate Commodity",
    nav: {
      home: "Accueil",
      commodities: "Nos matières premières",
      about: "À propos",
      expertise: "Notre expertise",
      why: "Pourquoi nous choisir",
      export: "Exportation internationale",
      contact: "Nous contacter",
    },
    buttons: {
      discover: "Découvrir nos matières premières",
      contact: "Nous contacter",
      viewDetails: "Voir la fiche",
      backToCommodities: "Retour aux matières premières",
      send: "Envoyer",
      sending: "Envoi en cours…",
      startChat: "Démarrer la conversation",
      chatSend: "Envoyer",
    },
    footer: {
      tagline: "Approvisionnement fiable en matières premières agricoles d'exception, de l'Afrique centrale vers le monde.",
      explore: "Explorer",
      legalTitle: "Informations",
      privacy: "Politique de confidentialité",
      mentions: "Mentions légales",
      rights: "Tous droits réservés.",
      newsletter: "Recevez nos actualités export",
      subscribe: "S'abonner",
      emailPlaceholder: "Votre adresse e-mail",
    },
    form: {
      firstName: "Prénom",
      lastName: "Nom",
      company: "Entreprise (optionnel)",
      email: "Adresse e-mail",
      subject: "Objet",
      message: "Message",
      success: "Merci ! Votre message a bien été envoyé.",
      error: "Une erreur est survenue. Veuillez réessayer.",
    },
    chat: {
      title: "Discutons",
      subtitle: "Une question ? Notre équipe export vous répond.",
      namePrompt: "Présentez-vous pour commencer",
      firstName: "Prénom",
      lastName: "Nom",
      email: "Adresse e-mail",
      placeholder: "Écrivez votre message…",
      intro: "Bonjour, comment pouvons-nous vous accompagner aujourd'hui ?",
    },
    langLabel: "Langue",
  },

  home: {
    hero: {
      overline: "Négoce & Exportation de matières premières",
      title: "L'excellence agricole du Congo, vers les marchés internationaux.",
      subtitle:
        "Lauréate Commodity sélectionne, prépare et exporte des matières premières agricoles d'exception, avec traçabilité et accompagnement sur mesure.",
    },
    presentation: {
      overline: "01 — Qui nous sommes",
      title: "Un partenaire de confiance pour vos approvisionnements",
      body:
        "Née au cœur de l'Afrique centrale, Lauréate Commodity relie les producteurs du Congo-Brazzaville et de la République Démocratique du Congo aux acheteurs les plus exigeants du monde. Nous conjuguons rigueur logistique, exigence qualité et transparence pour livrer des matières premières à la hauteur des standards internationaux.",
    },
    values: {
      overline: "02 — Nos valeurs",
      title: "Ce qui nous distingue",
      items: [
        { title: "Traçabilité", text: "De la parcelle au port, chaque lot est documenté et contrôlé." },
        { title: "Exigence qualité", text: "Une sélection stricte pour répondre aux cahiers des charges les plus rigoureux." },
        { title: "Engagement humain", text: "Un accompagnement personnalisé à chaque étape de votre projet." },
        { title: "Vision internationale", text: "Une logistique pensée pour les marchés européens, asiatiques et américains." },
      ],
    },
    commitments: {
      overline: "03 — Nos engagements",
      title: "Une chaîne d'approvisionnement responsable",
      body:
        "Nous nous engageons pour une agriculture durable, une juste rémunération des producteurs et une empreinte maîtrisée. La qualité de nos produits est indissociable du respect des femmes et des hommes qui les cultivent.",
    },
    stats: {
      overline: "04 — En chiffres",
      title: "Une expertise qui s'exprime en résultats",
      items: [
        { value: "3", suffix: "", label: "Matières premières d'exception" },
        { value: "2", suffix: "", label: "Pays d'origine partenaires" },
        { value: "100", suffix: "%", label: "Lots tracés et contrôlés" },
        { value: "5", suffix: "+", label: "Continents desservis" },
      ],
    },
    commoditiesSection: {
      overline: "05 — Nos matières premières",
      title: "Une sélection rare, préparée avec soin",
      body: "Découvrez nos produits phares, cultivés dans les terroirs fertiles du bassin du Congo.",
    },
    whyChoose: {
      overline: "06 — Pourquoi nous choisir",
      title: "L'assurance d'un partenaire sérieux",
      items: [
        { title: "Origine maîtrisée", text: "Un réseau de producteurs sélectionnés au Congo-Brazzaville et en RDC." },
        { title: "Qualité constante", text: "Des process de préparation qui préservent l'intégrité du produit." },
        { title: "Logistique fiable", text: "Une gestion export de bout en bout, sans mauvaise surprise." },
        { title: "Relation directe", text: "Un interlocuteur unique, réactif et transparent." },
      ],
    },
    map: {
      overline: "07 — Nos origines",
      title: "Au cœur du bassin du Congo",
      body:
        "Nos matières premières proviennent de la République du Congo (Brazzaville) et de la République Démocratique du Congo, deux terroirs équatoriaux d'une richesse agronomique exceptionnelle.",
      countries: [
        { name: "République du Congo", city: "Brazzaville" },
        { name: "République Démocratique du Congo", city: "Kinshasa" },
      ],
    },
    exportSection: {
      overline: "08 — Exportation internationale",
      title: "Du terroir congolais aux marchés du monde",
      body:
        "Grâce à une chaîne logistique optimisée, nous acheminons nos matières premières vers l'Europe, l'Asie, l'Amérique et le Moyen-Orient, dans le respect des délais et des normes en vigueur.",
    },
    cta: {
      title: "Construisons ensemble votre prochain approvisionnement",
      body: "Nos équipes sont à votre disposition pour étudier vos besoins et vous proposer une offre sur mesure.",
      button: "Nous contacter",
    },
  },

  commodities: [
    {
      slug: "cafe",
      name: "Café en grains",
      tagline: "Un café d'altitude, préparé pour l'excellence",
      image: IMAGES.coffee,
      description:
        "Récolté à maturité dans les régions productrices du Congo-Brazzaville et de la République Démocratique du Congo, notre café est soigneusement préparé afin de préserver toute la qualité du grain avant son exportation.",
      origin: "Congo-Brazzaville & République Démocratique du Congo",
      quality: "Grains sélectionnés à maturité, séchage contrôlé, tri rigoureux.",
      use: "Torréfaction spécialité, mélanges premium, industrie agroalimentaire.",
      markets: "Europe, Amérique du Nord, Asie.",
      export: "Conditionnement export en sacs de jute, traçabilité complète par lot.",
    },
    {
      slug: "cacao",
      name: "Cacao en grains",
      tagline: "Des fèves équatoriales aux arômes profonds",
      image: IMAGES.cocoa,
      description:
        "Cultivé au cœur du Congo-Brazzaville et de la République Démocratique du Congo, notre cacao bénéficie d'un climat équatorial et de sols fertiles. Sélectionnées avec soin, nos fèves répondent aux exigences des professionnels de l'agroalimentaire, de la cosmétique et du bien-être.",
      origin: "Congo-Brazzaville & République Démocratique du Congo",
      quality: "Fèves fermentées et séchées avec soin, teneur en cacao optimale.",
      use: "Chocolaterie fine, cosmétique, beurre de cacao, bien-être.",
      markets: "Europe, Asie, Moyen-Orient.",
      export: "Sacs export standardisés, contrôle qualité à l'embarquement.",
    },
    {
      slug: "litchi",
      name: "Litchi du Congo",
      tagline: "La fraîcheur parfumée d'un fruit d'exception",
      image: IMAGES.lychee,
      description:
        "Cueilli à maturité dans des vergers sélectionnés, notre litchi est reconnu pour sa fraîcheur, sa chair parfumée et sa qualité. Chaque récolte est préparée avec soin pour répondre aux exigences des marchés internationaux.",
      origin: "Congo-Brazzaville",
      quality: "Fruits cueillis à maturité, calibrage et tri manuel.",
      use: "Consommation fraîche, transformation, jus et conserves haut de gamme.",
      markets: "Europe, Moyen-Orient, Asie.",
      export: "Chaîne du froid maîtrisée, conditionnement adapté à l'export.",
    },
  ],

  about: {
    hero: {
      overline: "À propos",
      title: "Lauréate Commodity, l'exigence au service de l'export",
      subtitle: "Un pont entre les terroirs d'Afrique centrale et les marchés internationaux.",
    },
    story: {
      title: "Notre histoire",
      body:
        "Lauréate Commodity est née d'une conviction simple : les matières premières d'Afrique centrale méritent d'accéder aux marchés les plus exigeants, dans des conditions de qualité et de transparence irréprochables. Depuis nos origines, nous bâtissons des relations durables avec les producteurs et les acheteurs, en plaçant la confiance au centre de chaque transaction.",
    },
    mission: {
      title: "Notre mission",
      body:
        "Offrir un approvisionnement fiable en matières premières agricoles de qualité, avec traçabilité et accompagnement personnalisé, tout en valorisant le savoir-faire des producteurs congolais.",
    },
    pillars: [
      { title: "Sélection", text: "Un sourcing rigoureux au plus près des terroirs." },
      { title: "Préparation", text: "Des process qui préservent la qualité intrinsèque des produits." },
      { title: "Exportation", text: "Une logistique internationale fiable et documentée." },
    ],
  },

  expertise: {
    hero: {
      overline: "Notre expertise",
      title: "Une maîtrise complète de la chaîne de valeur",
      subtitle: "De la sélection à la livraison, chaque étape est pensée pour l'excellence.",
    },
    steps: [
      { num: "01", title: "Sourcing & sélection", text: "Identification des meilleurs lots auprès de producteurs partenaires." },
      { num: "02", title: "Contrôle qualité", text: "Analyses, tri et validation selon les standards internationaux." },
      { num: "03", title: "Préparation & conditionnement", text: "Séchage, calibrage et conditionnement adaptés à l'export." },
      { num: "04", title: "Logistique & exportation", text: "Gestion documentaire, transport et suivi jusqu'à destination." },
    ],
  },

  why: {
    hero: {
      overline: "Pourquoi Lauréate Commodity",
      title: "Le partenaire export qui inspire confiance",
      subtitle: "Sérieux, transparence et exigence : les fondements de notre relation client.",
    },
    reasons: [
      { title: "Traçabilité totale", text: "Chaque lot est documenté, de la parcelle au port d'embarquement." },
      { title: "Qualité certifiée", text: "Des contrôles rigoureux à chaque étape pour une constance sans faille." },
      { title: "Accompagnement dédié", text: "Un interlocuteur unique pour un suivi réactif et personnalisé." },
      { title: "Portée internationale", text: "Une expérience des marchés européens, asiatiques et américains." },
      { title: "Engagement durable", text: "Une démarche responsable envers les producteurs et l'environnement." },
      { title: "Fiabilité logistique", text: "Des délais respectés et une gestion export sans faille." },
    ],
  },

  exportPage: {
    hero: {
      overline: "Exportation internationale",
      title: "Vos matières premières, livrées partout dans le monde",
      subtitle: "Une logistique export maîtrisée, du Congo aux quatre coins du globe.",
    },
    body:
      "Lauréate Commodity orchestre l'ensemble de la chaîne export : documentation douanière, conditionnement normé, transport maritime et suivi de livraison. Nous garantissons la conformité aux réglementations internationales et la traçabilité de chaque expédition.",
    capabilities: [
      { title: "Documentation complète", text: "Certificats d'origine, phytosanitaires et documents douaniers." },
      { title: "Transport maritime", text: "Partenariats avec des transitaires fiables pour des délais tenus." },
      { title: "Conditionnement normé", text: "Emballages conformes aux exigences des marchés de destination." },
      { title: "Suivi de A à Z", text: "Une visibilité totale sur l'acheminement de vos commandes." },
    ],
    regions: ["Europe", "Asie", "Amérique du Nord", "Moyen-Orient", "Afrique"],
  },

  contact: {
    hero: {
      overline: "Nous contacter",
      title: "Parlons de votre projet d'approvisionnement",
      subtitle: "Notre équipe vous répond dans les plus brefs délais.",
    },
    address: "Brazzaville, République du Congo",
    phone: "+242 00 000 000",
    email: "desyr@laureatecommodity.com",
    mapQuery: "Brazzaville, Congo",
    subjects: ["Demande de devis", "Renseignement produit", "Partenariat", "Autre"],
  },

  legal: {
    privacy: {
      title: "Politique de confidentialité",
      updated: "Dernière mise à jour : 2025",
      sections: [
        {
          heading: "1. Collecte des données",
          text: "Lauréate Commodity collecte les données que vous nous transmettez volontairement via nos formulaires de contact et de discussion (nom, prénom, e-mail, entreprise, message), uniquement dans le but de traiter votre demande.",
        },
        {
          heading: "2. Utilisation des données",
          text: "Vos données sont utilisées exclusivement pour répondre à vos demandes et assurer le suivi de la relation commerciale. Elles ne sont ni vendues ni cédées à des tiers.",
        },
        {
          heading: "3. Conservation",
          text: "Les données sont conservées pendant la durée nécessaire au traitement de votre demande et à nos obligations légales.",
        },
        {
          heading: "4. Vos droits",
          text: "Conformément à la réglementation applicable, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ces droits, contactez-nous à desyr@laureatecommodity.com.",
        },
      ],
    },
    mentions: {
      title: "Mentions légales",
      updated: "Dernière mise à jour : 2025",
      sections: [
        {
          heading: "Éditeur du site",
          text: "Le présent site est édité par Lauréate Commodity, entreprise spécialisée dans le négoce et l'exportation de matières premières agricoles.",
        },
        {
          heading: "Contact",
          text: "E-mail : desyr@laureatecommodity.com — Adresse : Brazzaville, République du Congo.",
        },
        {
          heading: "Propriété intellectuelle",
          text: "L'ensemble des contenus (textes, images, logos) présents sur ce site sont la propriété de Lauréate Commodity et ne peuvent être reproduits sans autorisation.",
        },
        {
          heading: "Hébergement",
          text: "Ce site est hébergé par un prestataire technique assurant la disponibilité et la sécurité des données.",
        },
      ],
    },
  },

  seo: {
    title: "Lauréate Commodity — Négoce & exportation de matières premières agricoles",
    description:
      "Lauréate Commodity exporte café, cacao et litchi d'exception depuis le Congo-Brazzaville et la RDC vers les marchés internationaux. Traçabilité, qualité et accompagnement sur mesure.",
  },
};

export const LANGUAGES = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
];
